import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class UnavailableSectionsStore {
  readonly ids = new Set<string>();
}
